import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';

const LANGUAGE_KEY = 'selectedLanguage';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private selectedLanguage: string = '';

  get currentLanguage() {
    return this.selectedLanguage;
  }

  constructor(private readonly translate: TranslateService) {}

  setDefaultLanguage() {
    const language = this.getLanguage();
    firstValueFrom(this.setSelectedLanguage(language)).catch(() => {
      this.setSelectedLanguage('en');
    });
  }


  setSelectedLanguage(language: string) {
    this.selectedLanguage = language;
    localStorage.setItem(LANGUAGE_KEY, language);

    return this.translate.use(language);
  }

  private getLanguage() {
    const storedLanguage = localStorage.getItem(LANGUAGE_KEY);
    const browserLanguage = this.translate.getBrowserLang();

    if(storedLanguage) {
      return storedLanguage;
    } else {
      if(browserLanguage === "en") {
        return "en";
      } else {
        return "es";
      }
    }
  } 
}
